<script setup lang="ts">
import { useIsSubmitting } from 'vee-validate'

defineProps<{ isLoading: boolean }>()
defineEmits<Emits>()

interface Emits {
  (event: 'cancel'): void
  (event: 'submit'): void
}

const isSubmittingForm = useIsSubmitting()
const showSaving = ref(isSubmittingForm.value)
const timeoutId = ref<NodeJS.Timeout | null>(null)
watch(isSubmittingForm, (isLoading) => {
  if (isLoading) {
    if (timeoutId.value)
      clearTimeout(timeoutId.value)
    showSaving.value = true
  }
  else {
    timeoutId.value && clearTimeout(timeoutId.value)
    timeoutId.value = setTimeout(() => {
      showSaving.value = false
    }, 1500)
  }
})
</script>

<template>
  <div id="form-submit-section" class="float">
    <IconButton is="a" class="w-15 h-15 text-softBlack hover:bg-softBlack hover:border-softBlack hover:text-white!  bg-white border-1 border-softGray rounded-full" href="#advanced">
      <IconAddWidget class="w-6 h-6" />
    </IconButton>
  </div>
</template>

<style lang="scss">
  .float {
    @apply sticky flex gap-2 items-center justify-end  bottom-8 right-0  z-50 px-2 w-fit ml-a ;
  }
</style>
